package com.patronat.top.ui.molecules.branding

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.patronat.top.ui.theme.AppIcons
import com.patronat.top.ui.theme.LabelLarge
import org.jetbrains.compose.resources.stringResource
import top.design_system.generated.resources.Res
import top.design_system.generated.resources.app_name_short

@Composable
fun AppLogo(
    modifier: Modifier = Modifier,
    iconSize: Int = 32,
    fontSize: Int = 18)
{
    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Image(
            painter = AppIcons.AppIconSmall,
            contentDescription = null,
            contentScale = ContentScale.Inside,
            modifier = Modifier
                .size(iconSize.dp)
                .clip(RoundedCornerShape(10.dp))
        )

        Spacer(modifier = Modifier.width(8.dp))

        Text(
            text = stringResource(Res.string.app_name_short),
            style = LabelLarge.copy(fontSize = fontSize.sp)
        )
    }
}
